import { IneligibleLines } from '../typings';

export const IN_ELIGIBILE_LINES_UNSUPPORTED_REASONS = [
  'IFP_LIMIT',
  'INVALID_SEGMENT',
  'INVALID_ACCESS',
  'LINE_ALREADY_PRESENT_IN_CART',
  'PREPAID_LINE',
];

// To use unique identifier in line list we combined line number and offer id with separated by '-' to give unique key and value to each plan.
// To get line number back we should to use below function.
export const getLineNumber = (lineNumberAndOfferIdString: string) => {
  return lineNumberAndOfferIdString.split('-')[0];
};

export const deriveOfferIdFromLineNumber = (
  lineNumberAndOfferIdString: string,
) => {
  return lineNumberAndOfferIdString.split('-')[1];
};

type UnsupportedIneligibleLines = {
  ineligibleLines: IneligibleLines;
  planKey: string;
};

export const getUnsupportedLinesForChangePlan = ({
  ineligibleLines,
  planKey,
}: UnsupportedIneligibleLines) => {
  if (!planKey || !ineligibleLines) {
    return [];
  }
  // filter and returns the unsupported lines for change plan
  const ineligibleLineNumber = getLineNumber(planKey);
  return ineligibleLines?.filter(({ lineNumber, reason }) => {
    return IN_ELIGIBILE_LINES_UNSUPPORTED_REASONS.some(
      (item) => item.includes(reason) && lineNumber === ineligibleLineNumber,
    );
  });
};
